var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLove28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.972 6.154a4.765 4.765 0 0 0-4.665 7.89h.001l8.191 8.513 8.192-8.512.001-.001a4.765 4.765 0 1 0-7.743-5.362.5.5 0 0 1-.9 0 4.764 4.764 0 0 0-3.077-2.528Zm12.082 8.235.36.347-8.554 8.889a.5.5 0 0 1-.72 0l-8.557-8.892a5.765 5.765 0 1 1 8.916-7.256 5.766 5.766 0 1 1 8.917 7.256l-.363-.344Z",
  clipRule: "evenodd"
})));
export { SvgLove28 as ReactComponent };
export default __webpack_public_path__ + "f700958ebc35f8811cc1b69af496fbea.svg";